const siteHeader = document.getElementById("site-header");
const menuToggle = document.getElementById("menu-toggle");
const mobileMenu = document.getElementById("mobile-menu");
const menuClose = document.getElementById("menu-close");
const siteFooter = document.getElementById("site-footer");

document.addEventListener("DOMContentLoaded", function() {

    if ( siteFooter && document.body.classList.contains('home') ) {
        const footerHeight = siteFooter.offsetHeight;

        document.documentElement.style.setProperty('--homepage-footer-height', footerHeight + 'px');
    }

    if ( siteHeader ) {
        const stickyOffset = siteHeader.offsetTop;

        window.addEventListener('scroll', function(){
            if ( window.scrollY > stickyOffset ) {
                siteHeader.classList.add('sticky');
            } else {
                siteHeader.classList.remove('sticky');
            }
        })
    }

    if ( menuToggle && mobileMenu ) {
        menuToggle.addEventListener("click", function(){
            if ( mobileMenu.classList.contains("active") ) {
                document.body.classList.remove("no-scroll");
                mobileMenu.classList.remove("active");
            } else {
                document.body.classList.add("no-scroll");
                mobileMenu.classList.add("active");
                mobileMenu.style.display = "flex";
                setTimeout(() => mobileMenu.style.opacity = 1, 250);
            }
        })
    }

    if ( menuClose && mobileMenu ) {
        menuClose.addEventListener("click", function(){
            if ( mobileMenu.classList.contains("active") ) {
                document.body.classList.remove("no-scroll");
                mobileMenu.classList.remove("active");
                mobileMenu.style.opacity = 0;
                setTimeout(() => mobileMenu.style.display = "none", 250);
            }
        })
    }


})